import * as t from 'io-ts';
import { PropertyValue } from '../components/configuration/types';

const Required = t.type({
    configuratorId: t.string,
    selections: t.type({
        properties: t.record(t.string, t.union([t.null, t.string, t.number])),
        attachments: t.record(t.string, t.string),
    }),
});

export const ConfigurationPostData = Required;
export type ConfigurationPostData = t.TypeOf<typeof ConfigurationPostData>;

/**
 * A serialised representation of the current configuration in the scene, including selections and attachment options.
 *
 */
export const InitialConfigurationDocument = t.intersection([
    ConfigurationPostData,
    t.type({ id: t.string }),
]);
export type InitialConfigurationDocumentT = t.TypeOf<typeof InitialConfigurationDocument>;

export function generate(
    properties: Record<string, PropertyValue>,
    attachments: Record<string, string>,
    configuratorId: string,
): ConfigurationPostData {
    return {
        configuratorId,
        selections: { properties, attachments },
    };
}

export function configurationsEqual(a: ConfigurationPostData, b: ConfigurationPostData): boolean {
    if (a.configuratorId !== b.configuratorId) {
        return false;
    }
    const aProperties = a.selections.properties;
    const aAttachments = a.selections.attachments;
    const bProperties = b.selections.properties;
    const bAttachments = b.selections.attachments;
    if (
        Object.keys(aProperties).length !== Object.keys(bProperties).length ||
        Object.keys(aAttachments).length !== Object.keys(bAttachments).length
    ) {
        return false;
    }
    const aPropertyKeys = Object.keys(aProperties);
    for (let i = 0; i < aPropertyKeys.length; i++) {
        const key = aPropertyKeys[i];
        if (aProperties[key] !== bProperties[key]) {
            return false;
        }
    }

    const aAttachmentKeys = Object.keys(aAttachments);
    for (let i = 0; i < aAttachmentKeys.length; i++) {
        const key = aAttachmentKeys[i];
        if (aAttachments[key] !== bAttachments[key]) {
            return false;
        }
    }

    return true;
}
